/*
 * @Author: XiuJie_Lin xiujie_lin@lebo.cn
 * @Date: 2023-05-10 16:29:36
 * @LastEditors: XiuJie_Lin xiujie_lin@lebo.cn
 * @LastEditTime: 2023-05-11 13:50:57
 * @FilePath: \web-sass\src\views\markManage\mixins.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  data() {
    return {
      /** 	媒资影片来源平台 */
      sourcePlatformOptions: {
        1: "腾讯",
        2: "优酷",
        3: "爱奇艺",
        8: "bilibili"
      },
      /** 媒资类型 */
      typeOptions: {
        1: "电视剧",
        2: "电影",
        3: "综艺",
        4: "少儿"
      },
      /** 媒资是否是主媒资 */
      primaryOptions: {
        true: "是",
        false: "否"
      },
      /** 媒资状态是否上下架 */
      statusOptions: {
        1: "上架",
        2: "下架"
      },
      /** 媒资付费状态 */
      payStatusOptions: {
        // 1-免费; 2-VIP; 3-付费
        1: "【免费】",
        2: "【VIP】",
        3: "【付费】"
      },
      /** 演员职务 */
      actorDutyOptions: {
        //1-演员;2-导演;3-编剧
        1: "演员",
        2: "导演",
        3: "编剧"
      },
      /** 剧集类型 */
      episodeTypeOptions: {
        1: "正片",
        2: "预告片"
      },
      /** 初始化方式 */
      initTypeOptions: {
        1: "自动",
        2: "手动"
      }
    };
  },
  methods: {
    valueToLabel(options, value, defaultValue = "-") {
      return options[value] || defaultValue;
    }
  }
};
